<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <div class="expande-horizontal column">
        <h3 class="mb-1 fonte-bold">Faça entregas com entregadores do ifood</h3>
        Integre sua conta do ifood aqui
      </div>
    </v-expansion-panel-header>
    <v-divider></v-divider>
    <v-expansion-panel-content>
      <v-flex xs12>
        <div class="expande-horizontal centraliza column px-6">
          <v-flex xs12>
            <v-window v-model="ifood_step">
              <v-window-item value="1">
                <v-flex xs12 class="pa-2">
                  <div class="expande-horizontal centraliza column">
                    <h3>Informe suas credenciais</h3>
                    <v-form>
                      <v-flex xs12>
                        <v-text-field
                          v-model="ifood_integration.merchant_id"
                          label="Merchant ID"
                          rounded
                          filled
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="ifood_integration.merchant_uuid"
                          label="Merchant UUID"
                          rounded
                          filled
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="ifood_integration.client_id"
                          label="Client ID"
                          rounded
                          filled
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="ifood_integration.client_secret"
                          label="Client Secret"
                          rounded
                          filled
                        ></v-text-field>
                      </v-flex>
                      <v-btn
                        color="red"
                        large
                        rounded
                        block
                        dark
                        :loading="loading"
                        @click="createIfoodIntegration"
                      >
                        <span class="fonte-bold">Cadastrar integração</span>
                      </v-btn>
                    </v-form>
                  </div>
                </v-flex>
              </v-window-item>
              <v-window-item value="2">
                <v-flex xs12>
                  <div class="expande-horizontal pa-3 centraliza">
                    <v-card class="pa-3" outlined style="border-radius: 12px;">
                      <div class="expande-horizontal centraliza column">
                        <v-avatar color="light-green" class="mb-3">
                          <v-icon dark>mdi-check-all</v-icon>
                        </v-avatar>
                        <h2 class="fonte-bold">Integração com ifood ativa</h2>
                        <span class="fonte grey--text fonteMini">
                          Client ID: {{ ifood_integration.client_id }}
                        </span>
                        <v-divider class="mt-6 mb-2"></v-divider>
                        <v-btn
                          v-if="!confirm_remove_ifood_integration"
                          @click="removeIfoodIntegration"
                          color="red lighten-3"
                          dark
                          text
                          x-small
                          rounded
                          >Remover Integração</v-btn
                        >
                        <v-btn
                          v-else
                          @click="confirmRemoveIfoodIntegration"
                          color="red"
                          dark
                          rounded
                          >Confirma a remoção?</v-btn
                        >
                        <v-btn
                          v-if="confirm_remove_ifood_integration"
                          @click="confirm_remove_ifood_integration = false"
                          color="grey"
                          dark
                          text
                          class="mt-2"
                          small
                          rounded
                          >Não</v-btn
                        >
                      </div>
                    </v-card>
                  </div>
                </v-flex>
              </v-window-item>
              <v-window-item value="3">
                <v-flex xs12>
                  <div class="expande-horizontal centraliza column">
                    <h2>
                      Erro ao integrar, verifique os dados e tente novamente
                    </h2>
                    <v-btn @click="ifood_step = '1'">Tentar novamente</v-btn>
                  </div>
                </v-flex>
              </v-window-item>
            </v-window>
          </v-flex>
        </div>
      </v-flex>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    confirm_remove_ifood_integration: false,
    ifood_step: "1",
    ifood_integration: {
      client_id: "",
      client_secret: ""
    }
  }),
  methods: {
    getIfoodIntegration() {
      this.loading = true;
      this.$run("marketplaces/get-ifood-integration")
        .then(res => {
          if (res.data.length === 0) {
            this.ifood_step = "1";
          } else {
            this.ifood_integration = res.data[0];
            this.ifood_step = "2";
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        })
        .finally(() => (this.loading = false));
      this.loading = false;
    },
    removeIfoodIntegration() {
      this.confirm_remove_ifood_integration = true;
    },
    confirmRemoveIfoodIntegration() {
      this.loading = true;
      this.$run("marketplaces/remove-ifood-integration")
        .then(() => {
          this.ifood_step = "1";
          this.ifood_integration = {};
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        })
        .finally(() => (this.loading = false));
      this.loading = false;
    },
    createIfoodIntegration() {
      this.loading = true;
      const payload = {
        client_id: this.ifood_integration.client_id,
        client_secret: this.ifood_integration.client_secret,
        merchant_uuid: this.ifood_integration.merchant_uuid,
        merchant_id: this.ifood_integration.merchant_id
      };
      this.$run("marketplaces/create-ifood-integration", payload)
        .then(res => {
          this.ifood_integration = res.data;
          this.ifood_step = "2"; //sucesso
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          this.ifood_step = "3"; //erro
          console.log(err);
        })
        .finally(() => (this.loading = false));
    }
  },
  mounted() {
    this.getIfoodIntegration();
  }
};
</script>

<style lang="scss">
.card-container {
  display: flex;
  position: relative;
  overflow: hidden;
  background: #f0f0f0;
  height: 400px;
  border-radius: 10px;
  width: 100%;
  cursor: pointer;
  border: 5px solid #333 !important;
  box-shadow: 0px 0px 10px 6px rgba(0, 0, 0, 0.2);
}
.card-content-layer {
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-repeat: no-repeat;
  transition: transform 0.3s ease;
  background: rgba(0, 0, 0, 0.5);
  background-size: cover;
  // background-image: url("");
}
.card-content {
  display: flex;
  width: 100%;
  height: 100%;
  transition: background 0.3s ease;
  transition: opacity 0.3s ease;
  background: rgba(0, 0, 0, 0.3);
  opacity: 0;
}
.default-template {
  border: 6px solid #9464e6 !important;
}
.card-content:hover {
  background: rgba(0, 0, 0, 0.3);
}
.card-content-layer:hover {
  transform: scale(1.1);
  .card-content {
    opacity: 1;
  }
}
</style>
